<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col lg:w-4/4 w-full relative">
        <vx-card title="" v-if="!isMobile()">
          <div class="demo-alignment" id="ustBolum">
            <div class="vx-col lg:w-8/12" style="">
              <div class="vx-row">
                <div class="vx-col lg:w-4/12" style="">
                  <v-select
                    :value="selected"
                    v-model="selected"
                    :options="[
                      { label: 'Aktif', id: '2' },
                      { label: 'Pasif', id: '3' },
                    ]"
                  ></v-select>
                </div>
                <div class="vx-col lg:w-4/12" style="">
                  <vs-input
                    v-if="!isMobile()"
                    class="inputx"
                    placeholder="Search"
                    id="kontrol"
                    @keyup.enter="siparisListele()"
                    :ref="siparisAdetKontrol"
                    v-model="siparisAdetKontrol"
                  />
                </div>
                <div class="vx-col lg:w-4/12" style="">
                  <vs-button
                    @click="siparisListele()"
                    style="border-radius: 5px"
                    color="danger"
                    type="gradient"
                    v-if="!isMobile()"
                    >Listele</vs-button
                  >
                </div>
              </div>
            </div>
            <div class="vx-col lg:w-4/12" style=""></div>
          </div>
        </vx-card>
        <vx-card title="" style="margin-top: 10px; font-size: 8px">
          <vs-table :data="sipariseGoreUrunListesi">
            <template slot="thead">
              <vs-th>Cari Kodu</vs-th>
              <vs-th>Cari Adı</vs-th>
              <vs-th>Şehir</vs-th>
              <vs-th>Tarih</vs-th>
              <vs-th>Güncelle</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].CARIKO">
                  {{ data[indextr].CARIKO }}
                </vs-td>

                <vs-td :data="data[indextr].CARIADI">
                  {{ data[indextr].CARIADI }}
                </vs-td>

                <vs-td :data="data[indextr].SEHIR">
                  {{ data[indextr].SEHIR }}
                </vs-td>

                <vs-td :data="data[indextr].GuncellemeTarihi">
                  {{
                    new Date(
                      data[indextr].GuncellemeTarihi
                    ).toLocaleDateString()
                  }}
                </vs-td>

                <vs-td :data="data[indextr].CARIKO">
                  <vs-button
                    @click="activePrompt = true"
                    class="cursor-pointer"
                    type="filled"
                    radius
                    color="warning"
                    icon="refresh"
                  >
                  </vs-button>
                </vs-td>
              </vs-tr>

              <vs-prompt
                title="Güncelleme İşlemi"
                acceptText="Güncelle"
                cancelText="Vazgeç"
                @accept="
                  durumGuncelle(
                    data[indextr].GuncellemeTarihi,
                    data[indextr].CARIKO
                  )
                "
                :active.sync="activePrompt"
              >
              </vs-prompt>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import state from "../../store/state";
import Store from "../../store/store";
import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
  components: {
    "v-select": vSelect,
    StreamBarcodeReader,
  },
  data() {
    return {
      text: "0",
      id: null,
      sayimDurumu: true,
      popupBilgiler: false,
      options: [
        { label: "Aktif", id: "2" },
        { label: "Pasif", id: "3" },
      ],
      optionsParti: [],
      pazaryeriTum: [],
      list: [],
      ciktiRenkListesi: [],
      listSonFaturalar: [],
      listSiparis: [],
      sipariseGoreUrunListesi: [],
      progress: 0,
      activePrompt: false,
      popupRenk: false,
      pazaryeriVal: "",
      partiVal: "",
      toplamParca: 0,
      selected: { id: 2, label: "Aktif" },
      selectedDepo: "",
      iadeModel: { id: 0, label: "İade red" },
      selectedParti: { id: 0, label: "Parti Nolar" },
      popupActive: false,
      popupFatura: false,
      popupActiveSiparis: false,
      popupActiveCikti: false,
      barkod: "",
      gidenDurum: "",
      barkodAdet: "",
      cariKod: "",
      siparisBulOrderNumber: "",
      genelSiparisNo: "",

      genelKargoAdi: "",
      genelKargoNo: "",
      genelMusteri: "",
      hediyeMi: 0,
      genelToplam: 0,
      eklenenDeger: "",
      indext: 0,
      indext1: 0,
      urunResim: "",
      validated: 1,
      validatedF: 1,
      siparisToplamParca: 0,
      eklenenToplamParca: 0,
      askiDurumu: false,
      aski: 0,
      imageLink: "",
      ciktiListesi: [],
      jsonD: "",
      dr: "",
      popupActiveFaturaCikti: false,
      receiptId: 0,
      faturaNo: "",
      ilkOkuma: 0,
      recId: 0,
      total: 0,
      faturaAranan: "",
      faturaBulOrderNumber: "",
      im: 0,
      iadeOrderNumber: "",
      iadeLineItemId: "",
      siparisAdetKontrol: "",
      ustBolumDeger: 0,
    };
  },
  methods: {
    siparisListele() {
      var vm = this;
      var vs = this.$vs;
      var id = this.selected.id;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        program: "Netsis",
        baslik: "siparisListesi",
        ARANAN: vm.siparisAdetKontrol,
        token: Store.state.tokenId,
        companyID: this.selected.label,
      };
      console.log(this.selected.label);
      //console.log(args);
      soap.createClient(url, function (err, client) {
        client.standartSorgular(args, function (err, result) {
          vm.veriler = JSON.parse(result.standartSorgularResult);

          console.log(vm.veriler);
          vm.sipariseGoreUrunListesi = vm.veriler;
          if (vm.veriler != null) {
            vs.loading.close("#button-with-loading-partile > .con-vs-loading");
            vs.notify({
              title: "Sipariş Listeleme",
              text: "Sipariş Yazıldı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              title: "Sipariş Listeleme",
              text: "Sipariş Çekme Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "error",
              position: "top-center",
            });
          }
        });
      });
    },
    /*ps() {
      //alert(this.selectedDepo)

      var vm = this;
      vm.sipariseGoreUrunListesi = null;
      vm.sipariseGoreUrunListesi = "";
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        program: "Netsis",
        baslik: "siparisListesi",
        DURUM: this.selected.id,
        ARANAN: this.siparisAdetKontrol,
        token: Store.state.tokenId,
      };
      soap.createClient(url, function(err, client) {
        client.standartSorgular(args, function(err, result) {
          vm.veriler = JSON.parse(result.standartSorgularResult);
          vm.sipariseGoreUrunListesi = vm.veriler;
          if (vm.veriler.response == "Ok") {
            vs.loading.close("#button-with-loading-partile > .con-vs-loading");
            vs.notify({
              title: "Sipariş Listesi",
              text: "Sipariş Yazıldı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center"
            });
          } else {
            vs.notify({
              title: "Sipariş Listeleme",
              text: "Sipariş Çekme Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "error",
              position: "top-center"
            });
          }
        });
      });
    },*/
    durumGuncelle(date, cariKod) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.selected.label == "Aktif") {
        vm.gidenDurum = "Pasif";
      } else {
        vm.gidenDurum = "Aktif";
      }
      //alert(vm.gidenDurum)
      const args = { tarih: date, cariKodu: cariKod, durum: vm.gidenDurum };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.toptanSiparisDurumGuncelle(args, function () {
          vm.siparisListele();
        });
      });
    },

    isMobile: function () {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-select .vs__selected {
  font-size: 10px;
}
.mb-base {
  margin-bottom: 0.75rem !important;
}
.list-view-item {
  .item-name,
  .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
